export default "__VITE_ASSET__CUrv86mP__"